import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

const CM_ANCHOR_CLASS = '.js-cmAnchor';
// const CM_CHARACTER_CLASS = '.js-cmCharacter';
// const CM_TVCM_CLASS = '.js-cmTvcm';
// const CM_WEBCM_CLASS = '.js-cmWebcm';
// const CM_MAKING_CLASS = '.js-cmMaking';

export class CmAnchors {
  constructor() {
    this.DOM = {};
    this.DOM.cmAnchor = document.querySelectorAll(CM_ANCHOR_CLASS);

    this.onInit();
  }

  onInit() {
    this._setAnchorClick();
    this._setScrollTriggers();
  }

  _setAnchorClick() {
    this.DOM.cmAnchor.forEach((a) => {
      a.addEventListener("click", (e) => {
        e.preventDefault();
        const target = e.currentTarget.getAttribute("data-link");
        gsap.to(window, {
          duration: 1,
          ease: 'power4.out',
          scrollTo: {
            y: target,
            autoKill: false
          }
        });
      });
    });
  }

  _setScrollTriggers() {
    this.DOM.cmAnchor.forEach((a) => {
      const targetSelector = a.getAttribute("data-link");
      const targetEl = document.querySelector(targetSelector);
      if (!targetEl) return;

      ScrollTrigger.create({
        trigger: targetEl,
        start: 'top center',
        end: 'bottom center',
        onEnter: () => a.classList.add('is-active'),
        onEnterBack: () => a.classList.add('is-active'),
        onLeave: () => a.classList.remove('is-active'),
        onLeaveBack: () => a.classList.remove('is-active'),
        // markers: true,
      });
    });
  }
}
